export default __webpack_public_path__ + "static/hoody-f725c4e2116d456dacef36f99e708714.png";